import { TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import { formatDollars } from '../../../../../common';
import { PreApprovalTrade, TradeAction } from '../store/types';
import { ExpiryType, PriceType } from '../../edit/store/types';

interface Props {
  trade: PreApprovalTrade;
  index: number;
  hasRebalanceEnhancedTrading: boolean;
  hasClientEditAdminOnlyPermission: boolean;
}

export default function PreapprovedTrade(props: Props): JSX.Element {
  const { trade, index, hasRebalanceEnhancedTrading, hasClientEditAdminOnlyPermission } = props;

  const priceType = trade.priceType ? trade.priceType : 'Market';
  let expiryType = 'Good For Day';

  switch (trade.expiryType) {
    case ExpiryType.GTC:
      expiryType = 'Good Till Cancelled';
      break;
    case ExpiryType.GTD:
      expiryType = 'Good Till Date';
      break;
    case ExpiryType.GFD:
      expiryType = 'Good For Day';
      break;
    default:
      expiryType = 'Good For Day';
      break;
  }

  const price = !trade.priceType || trade.priceType === PriceType.Market ? formatDollars(trade.unitPrice) : formatDollars(trade.priceLimit);

  return (
    <TableRow key={index}>
      <TableCell>
        <Typography variant="h5" color={'primary'}>
          {trade.securityCode}
        </Typography>
        <Typography variant="h5">{trade.securityName}</Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant="h5">{Intl.NumberFormat('en-AU').format(trade.calculatedTradeUnits)}</Typography>
        <Typography variant="h6" color={'textSecondary'}>
          @ {price}
        </Typography>
      </TableCell>
      <TableCell align="center">
        {trade.tradeAction === 'Buy' ? (
          <Typography variant="h5" color="secondary">
            BUY
          </Typography>
        ) : (
          <Typography variant="h5" color="error">
            SELL
          </Typography>
        )}
      </TableCell>
      {(hasRebalanceEnhancedTrading || hasClientEditAdminOnlyPermission) && (
        <TableCell>
          <Typography variant="h5">{priceType}</Typography>
        </TableCell>
      )}

      {(hasRebalanceEnhancedTrading || hasClientEditAdminOnlyPermission) && (
        <TableCell>
          <Typography variant="h5">{expiryType}</Typography>
        </TableCell>
      )}

      {(hasRebalanceEnhancedTrading || hasClientEditAdminOnlyPermission) && (
        <TableCell>
          <Typography variant="h5">{trade.expiryDate}</Typography>
        </TableCell>
      )}

      <TableCell align="right">
        <Typography variant="h5">
          {(trade.tradeAction === TradeAction.Sell || trade.tradeAction === TradeAction.All) && trade.calculatedTradeValue ? '-' : ''}
          {formatDollars(trade.calculatedTradeValue)}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
